/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWeatherLayer
 */
export interface OutputWeatherLayer {
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherLayer
     */
    altitudeM?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherLayer
     */
    avgSpeedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherLayer
     */
    maxSpeedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherLayer
     */
    points?: number;
}

/**
 * Check if a given object implements the OutputWeatherLayer interface.
 */
export function instanceOfOutputWeatherLayer(value: object): boolean {
    return true;
}

export function OutputWeatherLayerFromJSON(json: any): OutputWeatherLayer {
    return OutputWeatherLayerFromJSONTyped(json, false);
}

export function OutputWeatherLayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWeatherLayer {
    if (json == null) {
        return json;
    }
    return {
        
        'altitudeM': json['altitudeM'] == null ? undefined : json['altitudeM'],
        'avgSpeedMs': json['avgSpeedMs'] == null ? undefined : json['avgSpeedMs'],
        'maxSpeedMs': json['maxSpeedMs'] == null ? undefined : json['maxSpeedMs'],
        'points': json['points'] == null ? undefined : json['points'],
    };
}

export function OutputWeatherLayerToJSON(value?: OutputWeatherLayer | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'altitudeM': value['altitudeM'],
        'avgSpeedMs': value['avgSpeedMs'],
        'maxSpeedMs': value['maxSpeedMs'],
        'points': value['points'],
    };
}

